export default __webpack_public_path__ + "static/media/levain.51b5bd12.jpg";